<template>
  <button
    type="button"
    class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-transparent text-cockpit-muted transition-colors hover:border-cockpit-line hover:bg-cockpit-green/10 hover:text-cockpit-green focus:outline-none focus:ring-2 focus:ring-cockpit-green focus:ring-offset-1 focus:ring-offset-cockpit-surface">
    <i :class="icon" aria-hidden="true" />
  </button>
</template>

<script setup>
defineProps({
  icon: String,
})
</script>
